import React from 'react';
import {
    Box,
    Button,
    CardActions,
    Divider,
    FormHelperText,
    Grid,
    MenuItem,
    TextField,
    Typography,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import Conditional from '../../../components/Conditional';
import useChangeEvent from '../../../hooks/useChangeEvent';
import useLogic from './logic';
import useTitle from '../../../systems/TitleManager/useTitle';
import TestPicker from './TestPicker';
import TokenTypes from '@dyl/constants/TokenTypes';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.sm
    },
    title: { marginBottom: theme.spacing(3) },
    typeField: { marginBottom: theme.spacing(3) },
    testField: { marginBottom: theme.spacing(3) },
    divider: { marginBottom: theme.spacing(3) },
    countField: { marginBottom: theme.spacing(3) },
    descriptionField: { marginBottom: theme.spacing(5) },
}));

function TokensGeneratorLayout(props) {
    const classes = useStyles(props);

    const {
        type, setType,
        isLoadingTests, allTests,
        testId, setTestId,
        tokenCount, setTokenCount,
        description, setDescription,
        allowGenerate = true, onGeneratePress,
        allowExport = false, onExportPress,
        allowEdit,
    } = useLogic();

    useTitle({
        breadcrumbs: ['Passwords', 'Generate']
    });

    const onTypeSelect = useChangeEvent(setType);
    const onCountChange = useChangeEvent(setTokenCount);
    const onDescriptionChange = useChangeEvent(setDescription);

    return (
        <Box className={classes.root}>
            <Typography variant='h4' className={classes.title}>
                Generate Passwords
            </Typography>

            <Grid container>
                <Grid item xs={6}>
                    <TextField select
                        className={classes.typeField}
                        value={type}
                        onChange={onTypeSelect}
                        fullWidth
                        variant='filled'
                        label='What are these Passwords for?'
                        required
                        disabled={!allowEdit}
                    >
                        {TokenTypes.map(({ label, value }) => (
                            <MenuItem key={value} value={value}>
                                {label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>

            <Conditional if={!!type}>
                <Conditional if={type !== 'LIVE'}>
                    <Grid container>
                        <Grid item xs={8}>
                            <TestPicker
                                className={classes.testField}
                                label='Assign this test'
                                data={allTests}
                                value={testId}
                                onChange={id => setTestId(id)}
                                fullWidth
                                required
                                disabled={!allowEdit}
                                isLoading={isLoadingTests}
                            />
                        </Grid>
                    </Grid>
                </Conditional>

                <Divider
                    className={classes.divider}
                    variant='fullWidth'
                />

                <Grid container>
                    <Grid item xs={4}>
                        <TextField
                            className={classes.countField}
                            label='Number of Passwords'
                            value={tokenCount}
                            onChange={onCountChange}
                            fullWidth
                            variant='filled'
                            required
                            type='number'
                            disabled={!allowEdit}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={10}>
                        <TextField
                            className={classes.descriptionField}
                            label='Description'
                            value={description}
                            onChange={onDescriptionChange}
                            fullWidth
                            variant='filled'
                            required
                            disabled={!allowEdit}
                        />
                    </Grid>
                </Grid>
            </Conditional>

            <FormHelperText>
                * Required
            </FormHelperText>

            <Conditional if={!!type}>
                <CardActions>
                    <Button
                        variant='contained'
                        color='primary'
                        disabled={!allowGenerate}
                        onClick={onGeneratePress}
                    >
                        Generate
                    </Button>

                    <Button
                            variant='contained'
                            disabled={!allowExport}
                            onClick={onExportPress}
                        >
                            Export generated Passwords
                        </Button>
                </CardActions>
            </Conditional>
        </Box>
    );
}

export default TokensGeneratorLayout;